import { ArrowLeft } from '@carbon/icons-react';
import * as React from 'react';
import { Body, Button, Icon } from 'vet-bones/design-system/components';

import styles from 'src/components/resourceDialog/styles/drawerHeaderTitle.module.scss';

export type DrawerHeaderTitleProps = {
  title: string;
  onBack?: (() => void) | null;
  backButtonTestId?: string;
};

export const DrawerHeaderTitle: React.VFC<DrawerHeaderTitleProps> = ({
  title,
  onBack,
  backButtonTestId,
}) => {
  return (
    <div className={styles.drawerHeaderWithBack}>
      {onBack ? (
        <Button
          onClick={onBack}
          size="xs"
          testId={backButtonTestId}
          variant="new"
        >
          <Icon IconComponent={ArrowLeft} size="sm" />
        </Button>
      ) : null}
      <Body className={styles.drawerHeaderTitle} ellipsize size="2xl">
        {title}
      </Body>
    </div>
  );
};
